<template>
  <div class="overview-item">
    <div class="overview-icon">
      <span :class="elementIconClass" />
    </div>
    <div class="overview-detail">
      <span class="number-of-elements">
        {{ numberOfElement }}
      </span>
      <span class="overview-label">
        {{ elementLabel }}
        <router-link :to="elementLink" class="view-list" v-if="elementLink">
          {{ $t('common.view_list') }}
        </router-link>
      </span>
    </div>
  </div>
</template>

<script>
// import Chip from '@/components/common/Chip'

export default {
  components: {
    //Chip,
  },
  props: {
    numberOfElement: {
      type: Number,
      default: 0
    },
    elementLabel: {
      type: String
    },
    elementIconClass: {
      type: String
    },
    elementLink: {},
    elementNewLink: {},
    elementNewLinkImport: {},
    elementNewLabel: {},
    elementNewIconClass: {}
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/_colors.scss';

.overview-item {
  display: flex;
  flex-direction: row;
  padding-bottom: 56px;
}

.overview-icon {
  padding-right: 32px;
  display: flex;
  min-width: 45px;
  justify-content: center;

  & > span {
    width: 100%;
    &:before {
      width: 100%;
      height: 40px;
    }
  }
}

.overview-detail {
  display: flex;
  flex-direction: column;

  .number-of-elements {
    font-weight: bold;
    font-size: 28px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: $darker-blue;
    mix-blend-mode: normal;
  }

  .overview-label {
    font-weight: normal;
    font-size: 16px;
    // text-transform: capitalize;
    color: $darker-blue;

    padding-bottom: 8px;

    .view-list {
      padding-left: 12px;
      font-weight: 600;
      font-size: 12px;
      text-decoration-line: underline;
      color: $blue;
      mix-blend-mode: normal;
    }
  }
}
.actions {
  margin-top: 0px;
  margin-bottom: 0px;
  display: flex;
  justify-content: flex-start;

  &::v-deep .el-collapse {
    border: none;

    .el-collapse-item__header {
      min-width: 160px;
      // width: 140px;
      height: 40px;
      background: $purple;
      border: 2px solid $purple;
      border-radius: 45px;
      font-weight: 600;
      font-size: 14px;
      color: white;
      text-align: center;
      .button {
        width: 100%;
        i {
          font-size: 18px;
          vertical-align: text-top;
          margin-right: 2px;
        }
      }
    }

    .el-collapse-item__wrap {
      position: absolute;
      z-index: 2;
      margin-top: 8px;
      box-shadow: 0px 4px 7px rgba(4, 33, 50, 0.1);
      padding: 12px 16px;
      min-width: 220px;
    }
    .el-collapse-item__content {
      padding-bottom: 0;
    }
  }
}

.options {
  display: flex;
  flex-direction: row;
  align-items: center;
  display: flex;
  justify-items: flex-start;
  height: 40px;
}

.actions .options ::v-deep .el-collapse .el-collapse-item__header {
  background: linear-gradient(180deg, #29f4ff -46.11%, #5257ff 151.97%);
  box-shadow: 0px 8px 18px rgba(69, 137, 255, 0.26);
  border-radius: 50px;
  font-weight: bold;
  font-size: 14px;
  color: white;
  padding-right: 10px;

  &.is-active {
    color: white;
    background-color: $purple;
  }
}

::v-deep .action-item {
  display: flex;
  flex-direction: row;
  margin-top: auto;
  margin-bottom: auto;
  color: $purple;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  line-height: 22px;

  &:not(:last-of-type) {
    margin-bottom: 16px;
  }

  &:hover {
    font-size: 14px;
    font-weight: 800;
  }

  i {
    border-width: 2px;
    height: 16px;
    width: 16px;
    padding-right: 8px;
    font-size: 16px;
    margin: auto 0;
  }
}
</style>
